import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'

import { getStatus, getVersion, subscribe, type ConnectionState } from '../lib/connection'

/**
 * Baglanti durumu banner'i.
 *
 * ## Neden var
 *
 * `runStream` zaten jitter'li backoff ile yeniden bagliyordu ama bunu ARAYUZE
 * SOYLEMIYORDU. Kullanicinin gordugu sey "yanit bir yerde durdu ve hicbir sey
 * olmuyor" - uygulama calisiyor, kullanici bozuk sandigi icin sayfayi
 * yeniliyor, ve yenileme dogru olan seyi (sessizce yeniden baglanmayi)
 * gereksiz kiliyor.
 *
 * ## Uc durum, uc farkli mesaj
 *
 * Ucu de farkli bir sey soylemek ZORUNDA:
 *   * `offline`  -> "Yeniden dene" gostermek anlamsiz, once ag gerekiyor.
 *   * `retrying` -> kacinci deneme gorunuyor: bir seyin OLDUGU belli olmali.
 *   * `lost`     -> ACIK bir eylem gerekiyor; sessizce sonsuza kadar donmek
 *                   en kotu secenek.
 */
export function ConnectionBanner() {
  const { t } = useTranslation()
  // Sayac anlik goruntu: mutable nesne dondurmek `Object.is` karsilastirmasi
  // yuzunden re-render'i ATLAMASINA yol aciyor (bkz. `streamStore`).
  useSyncExternalStore(subscribe, getVersion, () => 0)
  const status = getStatus()

  if (status.state === 'ok') return null

  return (
    <div className={`conn conn-${status.state}`} role="status" aria-live="polite">
      <span>{message(status.state, status.attempt, t)}</span>
      {status.state === 'lost' && (
        <button
          type="button"
          className="copy"
          // Sayfa yenilemesi BILINCLI: `lost` durumunda okuyucular
          // birakilmis durumda ve uretim sunucuda devam ediyor. Temiz bir
          // yukleme `/api/runs/active` ile yarim kalan isi devraliyor - yani
          // kayipsiz ve elle bir "yeniden bagla" kodundan basit.
          onClick={() => window.location.reload()}
        >
          {t('common.retry')}
        </button>
      )}
    </div>
  )
}

function message(state: ConnectionState, attempt: number, t: TFunction): string {
  switch (state) {
    case 'offline':
      return t('conn.offline')
    case 'retrying':
      return t('conn.retrying', { attempt })
    case 'lost':
      return t('conn.lost')
    default:
      return ''
  }
}
